import { makeApiRequest } from 'actions/api';
import { GET_MENU_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getMenu = menuSlug =>
  makeApiRequest({
    requestType: GET_MENU_V3,
    method: RequestService.v3.getMenu,
    params: { menuSlug },
  });
